import { z as zod } from 'zod'
import * as Yup from 'yup'

import { DefaultSchemas } from './defaultSchemas'

export const MerchantBankAccountsDefaultSchemas = DefaultSchemas

export const MerchantBankAccountsDataSchemas = zod.object({
  bankAccountNumber: zod.string(),
  bankAccountTypeId: zod.number(),
  name: zod.string(),
  expiryDate: zod.string().nullable(),
  safetyCode: zod.number().nullable(),
  payerPartyCode: zod.string().nullable(),
  payerPartyParticulars: zod.string().nullable(),
  payeePartyRef: zod.string().nullable(),
  payeePartyCode: zod.string().nullable(),
  payeePartyParticulars: zod.string().nullable(),
  isDefaultBankAccount: zod.number(),
  settlementAccountName: zod.string().nullable(),
})

export const MerchantBankAccountsAPISchemas =
  MerchantBankAccountsDefaultSchemas.merge(
    zod.object({
      data: zod.array(MerchantBankAccountsDataSchemas),
    })
  )

export const AddMerchantBankAccountsAPISchemas =
  MerchantBankAccountsDefaultSchemas

export const UpdateMerchantBankAccountsAPISchemas =
  MerchantBankAccountsDefaultSchemas

export const MerchantBankAccountsFetchParamsSchemas = zod.object({
  traderId: zod.number().optional(),
  bankAccountNumber: zod.string().optional(),
  bankAccountTypeId: zod.number().optional(),
  name: zod.string().optional(),
  expiryDate: zod.string().nullable().optional(),
  safetyCode: zod.number().nullable().optional(),
  payerPartyCode: zod.string().nullable().optional(),
  payerPartyParticulars: zod.string().nullable().optional(),
  payeePartyRef: zod.string().nullable().optional(),
  payeePartyCode: zod.string().nullable().optional(),
  payeePartyParticulars: zod.string().nullable().optional(),
  isDefaultBankAccount: zod.number().optional(),
})

export const AddMerchantBankAccountsFetchParamsSchemas = zod.object({
  traderId: zod.number(),
  bankAccountNumber: zod.string().nullable(),
  bankAccountTypeId: zod.number(),
  name: zod.string(),
  expiryDate: zod.string().nullable(),
  safetyCode: zod.number().nullable(),
  payerPartyCode: zod.string().nullable(),
  payerPartyParticulars: zod.string().nullable(),
  payeePartyRef: zod.string().nullable(),
  payeePartyCode: zod.string().nullable(),
  payeePartyParticulars: zod.string().nullable(),
  isDefaultBankAccount: zod.number(),
})

export const AddMerchantBankAccountsFetchParamsSchemasYup = Yup.object({
  bankAccountNumber: Yup.string().required('Bank account number is required'),
  bankAccountTypeId: Yup.number().optional(),
  name: Yup.string().optional(),
  expiryDate: Yup.string().nullable().optional(),
  safetyCode: Yup.number().nullable().optional(),
  payerPartyCode: Yup.string().nullable().optional(),
  payerPartyParticulars: Yup.string().nullable().optional(),
  payeePartyRef: Yup.string().nullable().optional(),
  payeePartyCode: Yup.string().nullable().optional(),
  payeePartyParticulars: Yup.string().nullable().optional(),
  isDefaultBankAccount: Yup.number().optional(),
})

export const UpdateMerchantBankAccountsFetchParamsSchemas = zod.object({
  bankAccountNumber: zod.number().optional(),
  bankAccountTypeId: zod.number().optional(),
  name: zod.string().optional(),
  expiryDate: zod.string().nullable().optional(),
  safetyCode: zod.number().nullable().optional(),
  payerPartyCode: zod.string().nullable().optional(),
  payerPartyParticulars: zod.string().nullable().optional(),
  payeePartyRef: zod.string().nullable().optional(),
  payeePartyCode: zod.string().nullable().optional(),
  payeePartyParticulars: zod.string().nullable().optional(),
  isDefaultBankAccount: zod.number().optional(),
})

export const UpdateMerchantBankAccountsFetchParamsSchemasYup = Yup.object({
  bankAccountNumber: Yup.number().optional(),
  bankAccountTypeId: Yup.number().optional(),
  name: Yup.string().optional(),
  expiryDate: Yup.string().nullable().optional(),
  safetyCode: Yup.number().nullable().optional(),
  payerPartyCode: Yup.string().nullable().optional(),
  payerPartyParticulars: Yup.string().nullable().optional(),
  payeePartyRef: Yup.string().nullable().optional(),
  payeePartyCode: Yup.string().nullable().optional(),
  payeePartyParticulars: Yup.string().nullable().optional(),
  isDefaultBankAccount: Yup.number().optional(),
})